<script setup lang="tsx">
import { ref } from "vue";
import Dialog from "./Dialog.vue";
import IconLoading from "../icon/IconLoading.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Dialog, IconLoading },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    content?: string;
    closeWhenClickOverlay?: boolean;
    dur?: number;
  }>(),
  {
    content: "",
    closeWhenClickOverlay: false,
    dur: 200
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const dialog = ref();

function open() {
  dialog.value?.open();
}

function close() {
  dialog.value?.close();
}

defineExpose({
  open,
  close
});
</script>

<template>
  <Dialog
    ref="dialog"
    :showConfirm="false"
    :showTitle="false"
    :closeWhenClickOverlay="props.closeWhenClickOverlay"
    :dur="props.dur"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div class="loading">
      <div class="icon">
        <slot>
          <div style="width: 8em"><IconLoading></IconLoading></div>
        </slot>
      </div>
      <div
        v-if="content"
        class="content"
      >
        {{ content }}
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1em 1em;
}
.icon {
  padding: 2em 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  font-size: 1em;
  margin-top: -1em;
  margin-bottom: 1em;
}
</style>
